
import React from 'react'
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { PrimaryBtnOutlineAction, SecondaryBtnOutlineAction, CancelBtnOutlineAction } from '../../../styles/Common';
import { useTheme } from 'styled-components';
function ConfirmationModal({show, modalClosed, title, message, confirm, cancel}) {
    const {t} = useTranslation();
    const theme = useTheme()
   

    return (
        <>
            <Modal show={show} onHide={modalClosed} contentClassName="modal_w_mc" >
                <Modal.Header closeButton>
                <Modal.Title className="ICDBlue"> {title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="ADMCreationModal__body" style={{width: "650px"}}>
                    <p>
                        {message}
                    </p>
                </Modal.Body>
                <Modal.Footer>


                    <PrimaryBtnOutlineAction
                        style={{ background: theme.colors.success }}
                        bd={theme.colors.success}
                        onClick={confirm}
                    >
                        <span> Valider</span>
                             
                </PrimaryBtnOutlineAction>

        
                    <CancelBtnOutlineAction
                        color={theme.colors.danger}
                        border={theme.colors.danger}
                        onClick={cancel}
                    >
                        Annuler
                    </CancelBtnOutlineAction>

                   

                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ConfirmationModal

